// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"d2bfda34","147":"a2d5d8ca","371":"7d04446d","461":"23a05d97","610":"34e05415","705":"d3c503c0","786":"4c1aaf38"}[chunkId] + ".chunk.js";
};